import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../styles/Products.module.scss';
import { assetUrl } from '../../utils/imageUrl';
import { getFirstWholesaleTier, hasDiscount, hasWholesaleTiers } from '../../utils/productPrice';

const ProductGridCard = ({ product }) => {
  const { id, images, title, price, oldPrice, article, category } = product;
  const wholesaleTier = getFirstWholesaleTier(product);

  return (
    <Link to={`/products/${id}`} className={styles.product}>
      <div className={styles.image}>
        <img src={assetUrl(images?.[0])} alt={title} loading="lazy" />
      </div>
      <div className={styles.wrapper}>
        <h3 className={styles.title}>{title}</h3>
        {article && (
          <div className={styles.article}>Артикул: {article}</div>
        )}
        <div className={styles.cat}>{category?.name}</div>
        <div className={styles.info}>
          <div className={styles.prices}>
            <div className={styles.priceRow}>
              <div className={styles.price}>{price}₴</div>
              {hasDiscount(price, oldPrice) && (
                <div className={styles.oldPrice}>{oldPrice}₴</div>
              )}
            </div>
            {hasWholesaleTiers(product) && wholesaleTier && (
              <div className={styles.wholesale}>
                від {wholesaleTier.minQty} шт. — {wholesaleTier.price}₴
              </div>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProductGridCard;
